import { ThunkDispatch } from "core-integration/src/store";
import {
  getElementStats,
  getElementStatsByIdentifier,
} from "core-integration/src/store/element-stats/reducers";
import { IElementStat } from "core-integration/src/store/element-stats/types";
import { getElementTypesBySquadPosition } from "core-integration/src/store/element-types/reducers";
import { updateElementTypeControl } from "core-integration/src/store/elements/thunks";
import { getFutureEvents } from "core-integration/src/store/events/reducers";
import {
  listTableBody,
  listTableElementColumn,
  listTableHeader,
  listTablePosition,
  listTablePositionCell,
  listTableStatColumn,
} from "plos/src/styles/listTables.css";
import {
  fixedTable,
  scrollContainer,
  visuallyHidden,
} from "plos/src/styles/utils.css";
import { getElementTypeNameByCount } from "plos/src/utils";
import { positionsByElementType } from "plos/src/utils/positionsByElementType";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useOverlayContext } from "../../../contexts/OverlayContext";
import {
  fdrEventCount,
  useOverlayColumns,
} from "../../../hooks/useOverlayColumns";
import { OverlayHeaderCells } from "../../ListViewTable/OverlayCells";
import SquadListTableRow from "./SquadListTableRow";
import { SquadListTableProps } from "./types";

const SquadListTable = ({
  handleOpenElemListSheet,
  proposedElements,
  handleElementClick,
}: SquadListTableProps) => {
  const { t } = useTranslation("squad");

  const dispatch = useDispatch<ThunkDispatch>();

  const { selectedOverlay } = useOverlayContext();
  const stats = useSelector(getElementStats);
  const statsByName: Record<string, IElementStat> = useSelector(
    getElementStatsByIdentifier,
  );
  const fdrEvents = useSelector(getFutureEvents).slice(0, fdrEventCount);
  const elementTypesByPosition = useSelector(getElementTypesBySquadPosition);
  const currencyDivisor = 10;

  const showElementType = (elementTypeId: number) => {
    dispatch(updateElementTypeControl(elementTypeId));
  };

  const columns = useOverlayColumns(selectedOverlay, {
    stats,
    statsByName,
    fdrEvents,
  });

  return (
    <div className={scrollContainer}>
      <table aria-label={t("squadList", "Squad List")!} className={fixedTable}>
        <thead>
          <tr>
            <th scope="col" className={listTableElementColumn}>
              <div className={listTableHeader}>{t("player", "Player")}</div>
            </th>
            <OverlayHeaderCells columns={columns} />
            <th scope="col" className={listTableStatColumn}>
              <span className={visuallyHidden}>{t("remove", "Remove")}</span>
            </th>
          </tr>
        </thead>

        {Object.keys(positionsByElementType).map((et) => {
          const positions = positionsByElementType[et];

          return (
            <tbody className={listTableBody} key={et}>
              <tr>
                <th
                  scope="rowgroup"
                  className={listTablePositionCell}
                  colSpan={columns.length + 2}
                >
                  <div className={listTablePosition}>
                    {getElementTypeNameByCount(
                      positions,
                      elementTypesByPosition,
                    )}
                  </div>
                </th>
              </tr>
              {positions.map((pos) => (
                <SquadListTableRow
                  key={pos}
                  currencyDivisor={currencyDivisor}
                  elementTypesByPosition={elementTypesByPosition}
                  pos={pos}
                  proposedElements={proposedElements}
                  showElementType={showElementType}
                  handleOpenElemListSheet={handleOpenElemListSheet}
                  handleElementClick={handleElementClick}
                  overlay={selectedOverlay}
                  stats={stats}
                  columnCount={columns.length}
                />
              ))}
            </tbody>
          );
        })}
      </table>
    </div>
  );
};
export default SquadListTable;
